module.exports = __webpack_public_path__ + "946d06dc2ba749599bfcedc0cc995f9b.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/products/case.png
// module id = 691
// module chunks = 0